import React, { ReactElement, memo } from 'react'

import { PrivateCompanyIndicator } from '@components/PrivateCompanyIndicator'
import TruncateLines from '@components/TruncateLines'
import SharedContactsIcon from '@components/icons/SharedContactsIcon'
import { ProfileTitleCellProps } from '@modules/shortlist/types'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import Checkbox from '@mui/material/Checkbox'

import { ProfileTitleContainer, StyledProfileLogo, SubtitleWrapper, TitleContainer, TitleWrapper } from './index.styles'

const ProfileTitleCell = ({
  profileData,
  isSelectedProfile,
  onSelectProfile,
  onClickProfile,
  isDisabled,
  isPrivate,
  isDraggable = true,
  showCompanyName = false,
}: ProfileTitleCellProps): ReactElement => {
  const { globalId, profileTitle, profileId, profileImgData, profileType, profileHasSharedInfo } = profileData
  return (
    <>
      {isDraggable && <DragIndicatorIcon id="shortlist-move_handle" />}
      <Checkbox
        draggable="true"
        onDragStart={event => event.preventDefault()}
        checked={isSelectedProfile}
        onChange={() => {
          onSelectProfile(profileId)
        }}
      />
      <StyledProfileLogo width={26} height={26} profileData={profileImgData} profileType={profileType} circleView />
      <ProfileTitleContainer>
        <TitleContainer>
          <TitleWrapper $isDisabled={isDisabled} href={`/plus/profile/${globalId}/${profileType}`} onClick={onClickProfile}>
            <TruncateLines lines={5}>{profileTitle}</TruncateLines>
          </TitleWrapper>
          {isPrivate && <PrivateCompanyIndicator />}
          {profileHasSharedInfo && <SharedContactsIcon />}
        </TitleContainer>
        {showCompanyName && (
          <SubtitleWrapper variant="body1">
            <TruncateLines lines={1}>{profileData.companyName}</TruncateLines>
          </SubtitleWrapper>
        )}
      </ProfileTitleContainer>
    </>
  )
}

export default memo(ProfileTitleCell)
